import React, { useEffect } from 'react';
import Navigation from '../components/common/navigation';
import ProgressBar from '../components/common/ProgressBar';
import { useDispatch } from 'react-redux';
import {
  getCaloriesModal,
  getMealExchangeActiveDay,
  getMealExchangeDays,
  getSelectedCalories,
  getSelectedDays,
  getSelectedMeals,
  getSelectedOption,
} from '../redux/selectors/orderFormSelector';
import { useEffectOnce, useWindowSize } from 'react-use';
import {
  mealExchangeChangeActiveDay,
  mealExchangeCheckDays,
  storeCity,
} from '../redux/actions/orderFormActions';
import {
  getMenuMeals,
  getParsedFirstDay,
  handleClickNextBackButton,
  isNextBackButtonDisabled,
  parseTitle,
} from '../components/pages/mealExchangeStep/helpers/mealExchangeHelpers';
import { getServerConfig } from '../features/general/generalSlice';
import MealDetailsModal from '../components/pages/mealExchangeStep/components/MealDetailsModal';
import MealCaloriesModal from '../components/pages/mealExchangeStep/components/mealCaloriesModal';
import MealErrorModal from '../components/pages/mealExchangeStep/components/mealErrorModal';
import CarouselCalendar from '../components/pages/mealExchangeStep/components/CarouselCalendar';
import BoxStep from '../components/common/BoxStep';
import Button from '../components/common/Button';
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowLeft,
  faArrowRight,
  faPen,
} from '@fortawesome/free-solid-svg-icons';
import { faSync } from '@fortawesome/pro-regular-svg-icons';
import SmallReplaceIcon from '../assets/icons/smallReplaceIcon';
import CalendarSmallIllustration from '../assets/icons/calendarSmallIllustration';
import SummaryBar from '../components/pages/mealExchangeStep/components/SummaryBar';
import CalculatedMealsValues from '../components/pages/mealExchangeStep/components/CalculatedMealsValues';
import SideOrderCarousel from '../components/pages/mealExchangeStep/components/SideOrderCarousel';
import CarouselMeals from '../components/pages/mealExchangeStep/components/CarouselMeals';
import { getSelectedCity } from '../redux/selectors/summaryReducer.selectors';
import InfoToast from '../components/pages/mealExchangeStep/components/InfoToast';
import { useEnhancedEcommercePageInfo } from '../hooks/useEnhancedEcommercePageInfo';
import { useAppSelector } from '../config/hooks';
import { useGetApiFormSettingsQuery } from '../services/api/form/open/open.api';
import SmallMenu from '../assets/icons/SmallMenu';

const StepMenuConfiguration = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { width } = useWindowSize();

  const selectedDays = useAppSelector(getSelectedDays);
  const activeDay = useAppSelector(getMealExchangeActiveDay);
  const mealExchangeDaysList = useAppSelector(getMealExchangeDays);
  const { modalStatus } = useAppSelector(getCaloriesModal) || {};
  const selectedMeals = useAppSelector(getSelectedMeals);
  const selectedDietOptionId = useAppSelector(getSelectedOption)?.dietOptionId;
  const selectedCaloriesValue = useAppSelector(getSelectedCalories)?.calories;
  const selectedCity = useAppSelector(getSelectedCity);

  const { apiKey, companyId, serverUrl } =
    useAppSelector(getServerConfig) || {};

  const { data: formSettings } = useGetApiFormSettingsQuery(undefined, {
    skip: !companyId,
  });

  useEffectOnce(() => {
    dispatch(storeCity(selectedCity?.sectorId, selectedCity?.name));
    dispatch(mealExchangeChangeActiveDay(getParsedFirstDay(selectedDays)));
    dispatch(mealExchangeCheckDays());
  });

  useEffect(() => {
    if (
      activeDay &&
      !Object.values(mealExchangeDaysList[activeDay]?.mealsList || {}).length
    ) {
      dispatch(
        // @ts-ignore
        getMenuMeals(
          companyId,
          activeDay,
          selectedCaloriesValue,
          selectedDietOptionId,
          selectedMeals,
          serverUrl,
          apiKey
        )
      );
    }
  }, [
    activeDay,
    apiKey,
    companyId,
    dispatch,
    mealExchangeDaysList,
    selectedCaloriesValue,
    selectedDietOptionId,
    selectedMeals,
    serverUrl,
  ]);

  const { canSend, sendEvent } = useEnhancedEcommercePageInfo();

  useEffect(() => {
    canSend && sendEvent();
  }, [canSend, sendEvent]);

  const mealsListPerDay = Object.values(
    mealExchangeDaysList[activeDay]?.mealsList || {}
  );

  const sideOrdersPerDay = Object.values(
    mealExchangeDaysList[activeDay]?.sideOrders || []
  );

  const refs =
    mealsListPerDay.length &&
    // TODO ANY
    mealsListPerDay.reduce((acc: any, value: any) => {
      acc[value.id] = React.createRef();
      return acc;
    }, {});

  const someMealHasItems = mealsListPerDay?.some(
    // TODO ANY
    (item: any) => item.list.length > 0
  );

  useEffect(() => {
    if (!selectedDays.length) {
      navigate('/', { replace: true });
    }
  }, [navigate, selectedDays.length]);

  return (
    <>
      <Navigation />
      <ProgressBar />

      {selectedDays?.length ? (
        <>
          <MealDetailsModal />

          {modalStatus && (
            // @ts-ignore
            <MealCaloriesModal companyName={companyId} refs={refs} />
          )}

          <MealErrorModal />

          <CarouselCalendar companyId={companyId} />

          <InfoToast
            description="Możesz skonfigurować menu teraz lub później w panelu klienta"
            title="Pamiętaj!"
          />

          <div className="steps-page steps-page--meal-exchange-page">
            <div className="steps-page__container">
              {mealsListPerDay.length ? (
                <>
                  <BoxStep
                    containerClass="steps-page__box-step-borders"
                    mealExchangePage
                    noBottomMargin
                    overflowHidden
                    title={`Konfiguruj menu na ${parseTitle(activeDay)}`}
                  >
                    {someMealHasItems ? (
                      <>
                        <CalculatedMealsValues />

                        {mealsListPerDay.map((items: any) => (
                          // @ts-ignore
                          <div key={items.id} ref={refs[items.id]}>
                            <CarouselMeals
                              activeDay={activeDay}
                              items={items}
                              meals={mealsListPerDay
                                .filter(
                                  (curr: any) => curr.mealId === items.mealId
                                )
                                .map((curr: any) => curr.id)}
                              mealsListPerDay={mealsListPerDay}
                              // @ts-ignore
                              refs={refs}
                              sideOrdersPerDay={sideOrdersPerDay}
                            />
                          </div>
                        ))}

                        {!!sideOrdersPerDay.length && (
                          <SideOrderCarousel
                            activeDay={activeDay}
                            mealsListPerDay={mealsListPerDay}
                            sideOrdersPerDay={sideOrdersPerDay}
                          />
                        )}
                      </>
                    ) : (
                      <div className="display-flex flex-direction-column justify-content-center align-items-center text-align-center spacer-vertical-90">
                        <SmallMenu />

                        <h3 className="h400 spacer-bottom-6">
                          Menu niedostępne
                        </h3>

                        <p className="body-l">
                          Catering nie opublikował jeszcze menu na wybrany dzień
                        </p>
                      </div>
                    )}
                  </BoxStep>
                  <div className="steps-page__buttons">
                    <Button
                      buttonLink={width < 768}
                      colorBlank={width >= 768}
                      containerClass="color-primary"
                      disabled={isNextBackButtonDisabled(
                        0,
                        selectedDays,
                        activeDay
                      )}
                      icon={<FontAwesomeIcon icon={faArrowLeft} />}
                      label="Poprzedni dzień"
                      onClick={() => {
                        dispatch(
                          // @ts-ignore
                          handleClickNextBackButton(
                            'back',
                            activeDay,
                            selectedDays
                          )
                        );
                      }}
                      sizeLarge
                    />
                    <Button
                      buttonLink={width < 768}
                      colorBlank={width >= 768}
                      containerClass="color-primary"
                      disabled={isNextBackButtonDisabled(
                        selectedDays.length - 1,
                        selectedDays,
                        activeDay,
                        formSettings
                      )}
                      icon={<FontAwesomeIcon icon={faArrowRight} />}
                      iconRight
                      label="Następny dzień"
                      onClick={() => {
                        dispatch(
                          // @ts-ignore
                          handleClickNextBackButton(
                            'next',
                            activeDay,
                            selectedDays
                          )
                        );
                      }}
                      sizeLarge
                    />
                  </div>
                </>
              ) : (
                <BoxStep mealExchangePage>
                  <div className="basic-loader basic-loader--min-height">
                    <FontAwesomeIcon
                      className="font-size-60 color-gray-400"
                      icon={faSync}
                      spin
                    />
                  </div>
                </BoxStep>
              )}

              <div className="steps-page__info-container">
                <div>
                  <SmallReplaceIcon
                    className="small-replace-icon"
                    height={48}
                    width={48}
                  />
                </div>
                <p className="steps-page__info-text">
                  Możesz skonfigurować menu teraz lub też później w panelu
                  klienta
                </p>
              </div>
              <div className="steps-page__days-container">
                <CalendarSmallIllustration />
                <div className="steps-page__days">
                  <p className="label-s color-gray-500 spacer-bottom-4 white-space-nowrap">
                    Liczba dni zamówienia:
                  </p>
                  <div className="steps-page__days-count">
                    <p className="label-l color-gray-800">
                      {selectedDays?.length}
                    </p>
                    <Link to="/zamowienie">
                      <div className="display-flex align-items-center">
                        <div className="steps-page__days-count-icon">
                          <FontAwesomeIcon
                            className="color-primary"
                            icon={faPen}
                          />
                        </div>
                        <p className="body-s color-primary">Zmień</p>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <SummaryBar />
        </>
      ) : (
        <div className="basic-loader basic-loader--min-height">
          <FontAwesomeIcon
            className="font-size-60 color-gray-400"
            icon={faSync}
            spin
          />
        </div>
      )}
    </>
  );
};

export default StepMenuConfiguration;
